module.exports = __webpack_public_path__ + "static/media/logo122.66d35867.png";